import { fetcher } from "helpers/fetcher";

import {
  TGetCorpStaffMemberFilterReq,
  TGetCorpStaffMemberFilterRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorpStaffMemberFilter = async (
  params?: TGetCorpStaffMemberFilterReq
) => {
  return await fetcher<
    TGetCorpStaffMemberFilterRes,
    TGetCorpStaffMemberFilterReq
  >(ENDPOINT.CORPORATION.GET_CORP_STAFF_MEMBER_FILTER, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_CORP_STAFF_MEMBER_FILTER.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetCorpStaffMemberFilter = async (
  params?: TGetCorpStaffMemberFilterReq
) => {
  return (await getCorpStaffMemberFilter(params)).data;
};

queryGetCorpStaffMemberFilter._key = (
  params?: TGetCorpStaffMemberFilterReq
) => [ENDPOINT.CORPORATION.GET_CORP_STAFF_MEMBER_FILTER.url, params];
